"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.BurgerLabel = exports.BurgerContainer = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _mediaQueries = _interopRequireDefault(require("../../../styles/mediaQueries"));

var BurgerContainer = (0, _styled.default)('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  cursor: 'pointer'
});
exports.BurgerContainer = BurgerContainer;
var BurgerLabel = (0, _styled.default)('div')(function (_ref) {
  var _ref2;

  var _ref$theme = _ref.theme,
      space = _ref$theme.space,
      globalNav = _ref$theme.globalNav,
      variation = _ref.variation;
  return _ref2 = {
    textTransform: globalNav.burgerLabelTransform,
    marginLeft: "-".concat(space.xsmall),
    fontSize: globalNav.burgerLabelSizeMobile,
    color: 'inherit'
  }, _defineProperty(_ref2, _mediaQueries.default.untilSmall, {
    display: variation === 'mega' ? 'none' : 'block'
  }), _defineProperty(_ref2, _mediaQueries.default.medium, {
    fontSize: globalNav.burgerLabelSizeDesktop
  }), _defineProperty(_ref2, '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)', {
    marginTop: globalNav.burgerLabelMarginTopIE
  }), _ref2;
});
exports.BurgerLabel = BurgerLabel;